module.exports = __webpack_public_path__ + "static/giz-logo-86e264ec675710cd19d0c0131e9bc379.jpg";